const _excluded = ["selected", "onChange", "className", "disabled", "dateFormat", "showTime", "shouldFormatDate", "allowNullDate"],
  _excluded2 = ["data-testid"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { createTimezonedDate, getLocaleDateFormat, getLocaleDateTimeFormat } from './dateUtils';
const DatePicker = _ref => {
  let {
      selected,
      onChange,
      className,
      disabled,
      dateFormat,
      showTime,
      shouldFormatDate = true,
      allowNullDate
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const dataTestId = rest['data-testid'];
  const {
      'data-testid': _
    } = rest,
    restWithoutTestId = _objectWithoutProperties(rest, _excluded2);
  if (showTime && !dateFormat) {
    dateFormat = getLocaleDateTimeFormat();
  } else if (!dateFormat) {
    dateFormat = getLocaleDateFormat();
  }
  const handleDateChange = (date, name) => {
    let result = null;
    let formattedDate;
    let utcDate;
    if (date) {
      utcDate = createTimezonedDate(date);
      formattedDate = "".concat(utcDate.getDate(), "/").concat(utcDate.getMonth() + 1, "/").concat(utcDate.getFullYear());
    } else if (!date && allowNullDate) {
      utcDate = null;
      formattedDate = null;
    }
    if (!shouldFormatDate && !showTime) {
      date.setHours(0, 0, 0, 0);
    }
    result = shouldFormatDate ? formattedDate : utcDate;
    onChange(result);
  };
  const datePicker = /*#__PURE__*/React.createElement(ReactDatePicker, _extends({}, restWithoutTestId, {
    disabled: disabled,
    className: className || 'custom-datepicker-input form-control',
    selected: createTimezonedDate(selected),
    onChange: date => handleDateChange(date),
    dateFormat: dateFormat,
    showTime: showTime,
    showYearDropdown: true,
    timeFormat: "HH:mm"
  }));
  if (dataTestId) {
    return /*#__PURE__*/React.createElement("span", {
      "data-testid": dataTestId
    }, datePicker);
  }
  return datePicker;
};
export default DatePicker;